import type { FC, ReactNode } from 'react'

import { DomeMark } from '@/components/generals/dome-mark'

interface LegalArticleProps {
    eyebrow: string
    title: string
    updated?: string
    children: ReactNode
}

/** Shared frame for the Impressum and the privacy policy, written in German. */
export const LegalArticle: FC<LegalArticleProps> = ({ eyebrow, title, updated, children }): ReactNode => {
    return (
        <section data-section-tone='ivory' className='px-5 pb-28 pt-36 md:px-10 md:pb-40 md:pt-44' lang='de'>
            <div className='grid grid-cols-12 gap-x-6 gap-y-14'>
                <header className='col-span-12 lg:col-span-4'>
                    <div className='lg:sticky lg:top-32'>
                        <p className='flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.18em] text-tone-muted'>
                            <DomeMark className='w-3.5 text-tone-fg' />
                            {eyebrow}
                        </p>
                        <h1 className='mt-6 font-heading text-6xl font-light leading-[0.92] tracking-[-0.03em] md:text-7xl lg:text-[5.4vw]'>
                            {title}
                        </h1>
                        {updated && (
                            <p className='mt-6 font-mono text-[11px] uppercase tracking-[0.18em] text-tone-muted'>
                                {updated}
                            </p>
                        )}
                    </div>
                </header>

                <div className='col-span-12 max-w-2xl text-base leading-relaxed lg:col-span-7 lg:col-start-6 md:text-lg [&_a]:underline [&_a]:underline-offset-4 [&_h2]:mt-14 [&_h2]:border-t [&_h2]:border-tone-line [&_h2]:pt-6 [&_h2]:font-heading [&_h2]:text-3xl [&_h2]:font-light [&_h2]:leading-tight [&_h2:first-child]:mt-0 [&_h2:first-child]:border-t-0 [&_h2:first-child]:pt-0 md:[&_h2]:text-4xl [&_h3]:mt-8 [&_h3]:font-mono [&_h3]:text-[11px] [&_h3]:uppercase [&_h3]:tracking-[0.18em] [&_h3]:text-tone-muted [&_li]:mt-2 [&_p]:mt-4 [&_ul]:mt-4 [&_ul]:list-disc [&_ul]:pl-5'>
                    {children}
                </div>
            </div>
        </section>
    )
}
